import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Maximize2, X } from 'lucide-react';
import { IconButton } from './IconButton';
/** Grey viewer canvas with a white A4 sheet (210mm × 297mm). Document markup is the app’s. */
export function PaperFrame({ children, width, style, fileName, compact, embed, size = 'a4', maximised, onMaximise, onMinimise, }) {
    const a4 = size === 'a4' && width == null;
    useEffect(() => {
        if (!maximised || !onMinimise)
            return;
        const onKey = (e) => {
            if (e.key === 'Escape')
                onMinimise();
        };
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener('keydown', onKey);
        };
    }, [maximised, onMinimise]);
    const frame = (_jsx("div", { className: `tl-paper-frame${compact ? ' is-compact' : ''}${maximised ? ' is-max' : ''}`, "data-print-root": true, style: style, children: _jsxs("div", { className: `tl-paper-stack${a4 ? ' is-a4' : ''}`, style: width ? { width } : undefined, children: [fileName && (_jsxs("div", { className: "tl-paper-caption", children: [_jsx("span", { className: "truncate", children: fileName }), _jsxs("span", { className: "tl-paper-caption-meta", children: [_jsx("span", { children: "Page 1 of 1 \u00B7 100%" }), maximised
                                    ? onMinimise && _jsx(IconButton, { icon: _jsx(X, { size: 14, strokeWidth: 1.8 }), label: "Close", onClick: onMinimise, size: 26 })
                                    : onMaximise && _jsx(IconButton, { icon: _jsx(Maximize2, { size: 14, strokeWidth: 1.8 }), label: "Maximise", onClick: onMaximise, size: 26 })] })] })), _jsx("div", { className: `tl-paper${a4 ? ' is-a4' : ''}${embed ? ' is-embed' : ''}`, children: children })] }) }));
    if (maximised && typeof document !== 'undefined') {
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: `tl-paper-frame${compact ? ' is-compact' : ''}`, "aria-hidden": true, style: { visibility: 'hidden', pointerEvents: 'none', minHeight: 80 } }), createPortal(frame, document.body)] }));
    }
    return frame;
}
/** Print the on-screen A4 sheet (`@page size: A4`). Browser “Save as PDF” is the download. */
export function printA4() {
    window.print();
}
//# sourceMappingURL=PaperFrame.js.map